export default "__VITE_ASSET__1f17b75c__"